import { Fragment } from 'react'
import PropTypes from 'prop-types'
import 'flag-icons/css/flag-icons.min.css'

const flagsMap = {
    ENG: {
        src: 'gb-eng',
        name: 'England',
    },
    ESP: {
        src: 'es',
        name: 'Spain',
    },
    GRE: {
        src: 'gr',
        name: 'Greece',
    },
    IRL: {
        src: 'ie',
        name: 'Ireland',
    },
    NIR: {
        src: 'gb-nir',
        name: 'Northern Ireland',
    },
    SCT: {
        src: 'gb-sct',
        name: 'Scotland',
    },
    SWE: {
        src: 'se',
        name: 'Sweden',
    },
    WLS: {
        src: 'gb-wls',
        name: 'Wales',
    },
    POR: {
        src: 'pt',
        name: 'Portugal',
    },
    HK: {
        src: 'hk',
        name: 'Hong Kong',
    },
    USA: {
        src: 'us',
        name: 'United States of America'
    }
}

const Flag = ({ code }) => (flagsMap[code] ? <span className={`fi fi-${flagsMap[code].src} fis`}></span> : <Fragment>{code}</Fragment>)

Flag.propTypes = {
    code: PropTypes.string.isRequired,
}

export default Flag
